import {DOMOperator} from "../../../util/DOMOperator.js";

export class EmptyComponent extends DOMOperator {
    // 빈위젯 클래스
    // 게시글 TOP 5, 댓글 TOP 5, 프로젝트 채팅 메시지 TOP 5 = empty-rank
    // 주 평균 업무 요청/처리 건수 = empty-average
    // 주차별 업무 건수 = empty-line-graph
    // 프로젝트 업무 현황 = empty-prj
    // 담당자별 마감일 업무 지난 건수, 담당자별 평균 업무 처리 속도, 담당자별 업무 = empty-p-bar-graph
    // 담당자별 평균 업무 처리 속도, 그룹별 업무 = empty-bar-graph
    // 주차별 업무 증가 추이 = empty-trend
    constructor({emptyClass = "", emptyMsg = "", defaultClass}) {
        super(`
            <div class="${defaultClass?? 'widget-empty'} ${emptyClass}">
                <p>${emptyMsg}</p>
            </div>
        `);
    }
}
